export default __webpack_public_path__ + "static/media/Users2.c0590f50.svg";